jQuery(document).ready(function ($) {
    'use strict';

    $(document.body).on('change', '#continent-select', function() {

        var continent = $(this).find('option:selected').val();

        var $filter_items = $(this).closest('.coworkers').find('.coworker');

        $filter_items.each(function () {
            var continents = $(this).data('continent');

            if ( continents.indexOf( continent ) != -1 ) {
                $(this).show();
            } else {
                $(this).hide();
            }

        });

    });

});